// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app___10lSk","wrapper":"App__wrapper___2Lwvk"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/App/components/App.scss
// module id = 1207
// module chunks = 1